import type { ReactNode } from 'react';
import React, { useCallback, useMemo } from 'react';
import type { CurrencyType } from '@lt/components/utils/currency';
import RadioFilterGroup from './RadioFilterGroup';
import type { IFilter } from '../types';

type LabelInfo = {
  LABEL: ReactNode;
  TOOLTIP: string;
};

interface MultiToggleFilterGroupProps extends Omit<IFilter, 'onClear'> {
  labels: Record<number, LabelInfo>;
  filterName: string;
  filterLabel: string;
  labelIcon?: React.ReactNode;
  currencyCode: CurrencyType;
}

const MultiToggleFilterGroup = ({
  onChange,
  labelIcon = undefined,
  isMobile,
  className,
  data,
  labels,
  filterName,
  filterLabel,
  currencyCode,
}: MultiToggleFilterGroupProps) => {
  const handleChange = useCallback(
    (selectedId: number | string) => {
      const diff = data.map(({ id }) => ({
        id,
        selected: id === selectedId,
      }));
      onChange({ path: filterName, diff });
    },
    [filterName, onChange, data],
  );

  const options = useMemo(
    () =>
      data.map(({ selected, disabled, hotel_count, id, min_price }) => ({
        selected,
        disabled,
        hotel_count,
        id,
        name: labels[id].LABEL,
        min_price,
        currencyCode,
      })),
    [data, labels, currencyCode],
  );

  return (
    <RadioFilterGroup
      className={className}
      data={options}
      filterName={filterName}
      filterLabel={filterLabel}
      LabelComponent={labelIcon}
      onChange={({ id }) => handleChange(id)}
      isMobile={isMobile}
    />
  );
};

export default MultiToggleFilterGroup;
